export const api_url = process.env.REACT_APP_API_HTTP_URL;
export const ws_url = process.env.REACT_APP_API_WS_URL;
export const google_auth_client_id = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
export const maintenance_mode = process.env.REACT_APP_MAINTENANCE_MODE === 'TRUE' ? true : false;
